// @ts-nocheck: converted from JS

export const getItemIndexFromChunk = (itemIndexInChunk, chunkIndex, maxItemsPerChunk) =>
  parseInt(itemIndexInChunk, 10) + parseInt(chunkIndex, 10) * maxItemsPerChunk;

export const isLastRowFilled = (rows, maxColumnsPerRow) => rows?.[rows.length - 1]?.length >= maxColumnsPerRow;
